<template>
  <div class="root form-control p-0" :class="{ 'regex-active': regexIsActive, disabled }">
    <slot />
    <div class="right">
      <slot name="right" />

      <fieldset class="regex-container" :disabled="disabled">
        <button
          :title="appTranslate('Use regular expressions')"
          class="btn regex"
          :class="regexIsActive ? 'btn-primary' : 'btn-light'"
          type="button"
          @click="emit('update:modelValue', regexIsActive ? 'normal' : 'regex')"
        >
          <span style="font-size: 1.4em">.</span>
          *
          <template v-if="flagsModel !== undefined">
            /<input
              v-model="flagsModel"
              class="flags"
              placeholder="flags"
              :title="appTranslate('Regex flags')"
              tabindex="-1"
              @click="regexIsActive ? $event.stopPropagation() : undefined"
            />
          </template>
        </button>
      </fieldset>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useTranslation } from '@/composables/useTranslation'
import { SearchMode } from '@/models/Global'
import { computed } from 'vue'

const props = defineProps<{ modelValue?: SearchMode; flags?: string; disabled?: boolean }>()
const emit = defineEmits<{ 'update:modelValue': [value: string]; 'update:flags': [value: string] }>()

const { appTranslate } = useTranslation()

const regexIsActive = computed(() => props.modelValue === 'regex')

const flagsModel = computed({
  get: () => props.flags,
  set: (value: string) => emit('update:flags', value),
})
</script>

<style lang="scss" scoped>
.root {
  display: flex;
  align-items: center;
  position: relative;
}

.right {
  position: static;

  flex-shrink: 0;
  align-self: stretch;
  margin: 2px;

  display: flex;
  flex-direction: row;
}

button.regex {
  font-family: cursive;

  line-height: 1em;
  display: flex;
  height: 100%;
  align-items: center;

  &.btn-light {
    color: #aaa !important;
  }
}

.flags {
  min-width: 1em;
  text-align: left;

  border: transparent;
  background-color: transparent;
  color: inherit;
  width: 0;
  min-width: 2em;

  &::placeholder {
    color: #0002;
    font-family: unset;
    font-size: 0.8em;
  }
}

:deep(input) {
  padding: 5px 10px;
  flex-grow: 1;
  border: 0;
  outline: 0;

  &::-webkit-search-decoration,
  &::-webkit-search-cancel-button,
  &::-webkit-search-results-button,
  &::-webkit-search-results-decoration {
    display: none;
  }
}
</style>
